/* src/app/modules/shared/components/header-column/header-column-label/header-column-label.component.scss */
app-header-column-label {
  display: contents;
}
/*# sourceMappingURL=header-column-label.component.css.map */
